import React from 'react';
import { User } from 'lucide-react';
import { type BemanningUser } from '../hooks/useDraftBemanningDrawer';
import { type UseDraftBemanningReturn } from '@/hooks/useDraftBemanning';
import { UserCard } from './UserCard';

interface UserListProps {
  users: BemanningUser[];
  displayList: BemanningUser[];
  loading: boolean;
  showAllUsers: boolean;
  selectedUsers: Set<number>;
  selectedTalentName: string | null;
  draft: UseDraftBemanningReturn;
  onToggleUser: (userId: number, event?: React.MouseEvent) => void;
}

export const UserList: React.FC<UserListProps> = ({
  displayList,
  loading,
  showAllUsers,
  selectedUsers,
  selectedTalentName,
  draft,
  onToggleUser,
}) => {
  if (loading) {
    return (
      <div className="flex justify-center p-8">
        <div className="text-muted-foreground">Laster...</div>
      </div>
    );
  }

  if (displayList.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-8 text-center">
        <User className="h-12 w-12 text-muted-foreground mb-2" />
        <p className="text-sm text-muted-foreground">
          Ingen medarbeidere funnet
        </p>
      </div>
    );
  }

  return (
    <>
      <p className="px-3 py-2 text-sm text-muted-foreground">
        {showAllUsers ? 'Alle medarbeidere' : 'Tilgjengelige medarbeidere'} ({displayList.length})
        {selectedUsers.size > 0 && ` • ${selectedUsers.size} valgt`}
      </p>
      <div className="flex-1 overflow-y-auto px-3">
        {displayList.map((user) => {
          const isSelected = selectedUsers.has(user.id);
          const isAllokert = !!user.allokertTalenter && user.allokertTalenter.length > 0;
          const isInDraft = draft.pendingChanges.added.some(
            p => p.id === user.id && (p as any).talent_navn === selectedTalentName
          );
          const isRemovedFromDraft = draft.pendingChanges.removed.some(p => p.id === user.id);
          
          return (
            <UserCard
              key={`user-${user.id}`}
              user={user}
              selectedTalentName={selectedTalentName}
              isSelected={isSelected}
              isAllokert={isAllokert}
              isInDraft={isInDraft}
              isRemovedFromDraft={isRemovedFromDraft}
              onToggle={onToggleUser}
            />
          );
        })}
      </div>
    </>
  );
};

